module.exports = __webpack_public_path__ + "static/img/index-tab3.100e79e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-tab3.png
// module id = QnCW
// module chunks = 1